import { render, staticRenderFns } from "./birth-date-input.vue?vue&type=template&id=32b461b2&scoped=true&lang=pug"
import script from "./birth-date-input.vue?vue&type=script&lang=js"
export * from "./birth-date-input.vue?vue&type=script&lang=js"
import style0 from "./birth-date-input.vue?vue&type=style&index=0&id=32b461b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b461b2",
  null
  
)

export default component.exports